<template>
  <div>
    <button
      v-if="canInstall && isMobile"
      @click="installPwa"
      class="install-btn"
    >
      Instalar app
    </button>
  </div>
</template>

<script>
export default {
  name: "InstallPwaButton",
  data() {
    return {
      canInstall: false,
      isMobile: false,
    };
  },
  created() {
    // Mismo criterio que PageBase.vue: pantalla del dispositivo < 992px = móvil
    this.isMobile = window.screen.width < 992;
    this.canInstall = !!this.$getPwaDeferredPrompt();
    this._onAvailable = () => { this.canInstall = true; };
    this._onInstalled = () => { this.canInstall = false; };
    window.addEventListener('pwa-install-available', this._onAvailable);
    window.addEventListener('pwa-installed', this._onInstalled);
  },
  beforeDestroy() {
    window.removeEventListener('pwa-install-available', this._onAvailable);
    window.removeEventListener('pwa-installed', this._onInstalled);
  },
  methods: {
    async installPwa() {
      const deferredPrompt = this.$getPwaDeferredPrompt();
      if (!deferredPrompt) return;
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      this.$clearPwaDeferredPrompt();
      this.canInstall = false;
    },
  },
};
</script>

<style scoped>
.install-btn {
  position: fixed;
  bottom: 16px;
  right: 16px;
  padding: 10px 16px;
  border-radius: 999px;
  border: none;
  background: #00BCD4;
  color: white;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0,0,0,.2);
}
</style>
